import React from 'react'

const Expenses = () => {
    return (
        <div>
            <header>
                <h2>Expenses</h2>
            </header>
            <article>
                <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Culpa, provident facere doloribus magnam eum aliquam.
                </p>
            </article>
        </div>
    )
}

export default Expenses
